import {Dropdown, Menu, Tooltip, Typography} from "antd";
import {
    AppstoreOutlined,
    ClusterOutlined,
    CodeOutlined,
    FileOutlined,
    FolderOpenOutlined,
    GlobalOutlined,
    ImportOutlined,
    InfoCircleOutlined,
    ReloadOutlined,
    SettingOutlined,
    SnippetsOutlined,
    ToolOutlined,
    UserOutlined
} from "@ant-design/icons";
import React from "react";
import {connect, RootStateOrAny} from "react-redux";
import {Link} from "react-router-dom";
import {APP_PREFIX_PATH} from "../../configs/AppConfig";
import {reLoad} from "../../redux/actions/Setup";
import IUser from "../../model/interface/security/IUser";
import UsersService from "model/service/security/UsersService";
import LocaleText from "../app/settings/dictionary/LocaleText";

interface IProps {
    reLoad: () => void
    user: IUser
}

interface IState {
}

class NavConfiguration extends React.Component<IProps, IState> {
    render() {
        const {user} = this.props
        return (
            <Tooltip title={<LocaleText code={'nav-menu.tools.tooltip'} fallback={"Nástroje pro správu"}/>} placement={'bottom'}>
                <Dropdown placement="bottomCenter" overlay={(
                    <div className="nav-profile nav-dropdown p-2">
                        <Typography.Title level={3} className={"text-center"}><LocaleText code={'nav-menu.tools'} fallback={"Nástroje"}/></Typography.Title>

                        <Menu className={"border-0"}>
                            <Menu.Item onClick={() => this.props.reLoad()} icon={<ReloadOutlined/>}>
                                <span><LocaleText code={'nav-menu.tools.refresh'} fallback={"Aktualizovat nastavení"}/></span>
                            </Menu.Item>
                            {UsersService.hasCredential(user, 'configuration') && (
                                <Menu.Item icon={<SettingOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/configuration`}>
                                        <span><LocaleText code={'nav-menu.tools.configuration'} fallback={"Konfigurace"}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            {UsersService.hasCredential(user, 'template_configuration') && (
                                <Menu.Item icon={<SnippetsOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/configuration/templates`}>
                                        <span><LocaleText code={'nav-menu.tools.template-configuration'} fallback={"Konfigurovat ze šablony"}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            {UsersService.hasCredential(user, 'files') && (
                                <Menu.Item icon={<FolderOpenOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/file-manager`}>
                                        <span><LocaleText code={'nav-menu.tools.filesystem'} fallback={"Datový sklad"}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            {UsersService.hasCredential(user, 'company') && (
                                <Menu.Item icon={<ClusterOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/company/configuration`}>
                                        <span><LocaleText code={'nav-menu.tools.company'} fallback={"Nastavení společnosti"}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            {UsersService.hasCredential(user, 'import') && (
                                <Menu.Item icon={<ImportOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/import`}>
                                        <span><LocaleText code={'nav-menu.tools.import'} fallback={"Import"}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            {UsersService.hasCredential(user, 'settings') && (
                                <Menu.Item icon={<ToolOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/settings`}>
                                        <span><LocaleText code={'nav-menu.tools.settings'} fallback={"Nastavení"}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            {UsersService.hasCredential(user, 'users') && (
                                <Menu.Item icon={<UserOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/security/users`}>
                                        <span><LocaleText code={'nav-menu.tools.users'} fallback={"Uživatelé"}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            {UsersService.hasCredential(user, 'generatedDocuments') && (
                                <Menu.Item icon={<FileOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/generated-documents`}>
                                        <span><LocaleText code={'tools.document-generator'} fallback={'Generátor dokumentů'}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            {UsersService.hasCredential(user, 'symfony-console') && (
                                <Menu.Item icon={<CodeOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/symfony-console`}>
                                        <span><LocaleText code={'nav-menu.tools.symfony-console'} fallback={"Symfony konzole"}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            {UsersService.hasCredential(user, 'dictionary-settings') && (
                                <Menu.Item icon={<GlobalOutlined/>}>
                                    <Link to={`${APP_PREFIX_PATH}/dictionary-settings`}>
                                        <span><LocaleText code={'nav-menu.tools.dictionary'} fallback={"Slovník"}/></span>
                                    </Link>
                                </Menu.Item>
                            )}
                            <Menu.Item icon={<InfoCircleOutlined/>}>
                                <Link to={`${APP_PREFIX_PATH}/security/version`}>
                                    <span><LocaleText code={'nav-menu.tools.license'} fallback={"Licence a verze"}/></span>
                                </Link>
                            </Menu.Item>
                        </Menu>
                    </div>
                )} trigger={["click"]}>
                    <div>
                        <AppstoreOutlined className="nav-icon mx-auto"/>
                    </div>
                </Dropdown>
            </Tooltip>
        )
    }
}

const mapStateToProps = (state: RootStateOrAny) => {
    const {user} = state.setup
    return {
        user
    }
}


const mapDispatchToProps = (dispatch: any) => {
    return {
        reLoad: () => dispatch(reLoad())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavConfiguration)
